/**
 * 设置模块下定义变量
 * 不同环境状态下定义不同的变量状态
 */
module.exports = {
  // aplication name
  name: 'ObsSwap',
  // api url
  baseOneURL: 'https://unpkg.com/',
  // pioneer rpc
  pioneerRPC: 'http://rpc-testnet.iniscan.com',
  // pioneer rpc
  pioneerScan: 'https://testnet.iniscan.com',
  // genesis rpc 
  genesisRPC: 'http://rpc-testnet.inichain.com',
  // pioneer rpc
  genesisScan: 'https://genesis-testnet.iniscan.com',
  // wallet Connect
  walletConnectBridge: 'https://bridge.walletconnect.org',
  // info market
  infoMarket:'https://testinfo.obsswap.org'
}